import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M15.74 6.21H13.6c-1.05 0-1.98.5-2.6 1.27a3.3 3.3 0 0 0-2.6-1.27H6.26c-.86 0-1.75.65-1.75 1.75v5.98c0 .44.19.88.53 1.22s.78.53 1.22.53h2.71c.45 0 .83.16 1.07.44.02.45.39.8.85.8h.23c.44 0 .79-.33.84-.8.24-.28.63-.44 1.08-.44h2.71c1.09 0 1.75-.89 1.75-1.75V7.96c0-1.09-.89-1.75-1.75-1.75Zm-5.7 7.96c-.34-.11-.7-.17-1.07-.17H6.29l-.09-.06V7.92l-.19-.21.24.19h2.14c.89 0 1.64.75 1.64 1.64v4.63Zm5.75-.23-.06.06h-2.71c-.37 0-.73.06-1.07.17V9.54c0-.89.75-1.64 1.64-1.64h2.14l.06.06z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M11 0C4.92 0 0 4.92 0 11s4.92 11 11 11 11-4.92 11-11S17.08 0 11 0m0 20.31c-5.14 0-9.31-4.17-9.31-9.31S5.86 1.69 11 1.69s9.31 4.17 9.31 9.31-4.17 9.31-9.31 9.31"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }